import { render, staticRenderFns } from "./VenturaUserMobileView.vue?vue&type=template&id=40b77363&scoped=true&"
import script from "./VenturaUserMobileView.vue?vue&type=script&lang=js&"
export * from "./VenturaUserMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b77363",
  null
  
)

export default component.exports